import { render, staticRenderFns } from "./HorizontalFeatures.vue?vue&type=template&id=7a20d77c&"
import script from "./HorizontalFeatures.vue?vue&type=script&lang=js&"
export * from "./HorizontalFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports